import React, { useState, useEffect, useRef } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormGroup,
  FormControlLabel,
  Switch
} from "@mui/material";


import { TextInput } from "../../../Components/Input/Input";
import { ButtonSave, ButtonClose } from "../../../Components/Button/Button";
import axios from "axios";
import { UrlApi, authorization } from "../../../UrlApi/UrlApi";
import Loading from "../../../Components/Loading/Loading";
import {
  AlertError,
  AlertSuccess,
} from "../../../Components/AlertDialog/AlertDialog";
import SelectAutoComplete from "../../../Components/Input/Input";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import Box from "@mui/material/Box";
import { userData } from "../../../DataContext/DataContext";
import { useRecoilValue } from "recoil";
import Typography from '@mui/material/Typography';
import { SelectDate } from "../../../Components/Input/Input";
import moment from "moment";

function AddWorkArea(props) {
  const user = useRecoilValue(userData);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(true)
  const [workAreaErr, setWorkAreaErr] = useState(false);
  const [zoneErr, setZoneErr] = useState(false);

  const [zoneId, setZoneId] = useState("");
  const [areaName, setAreaName] = useState("");
  const [zoneName, setZoneName] = useState("");
  const [zoneData, setZoneData] = useState([]);

  const onSubmit = async (event) => {
    event.preventDefault();
    if (areaName === "") {
        setWorkAreaErr(true);
        return false;
      } else {
        setWorkAreaErr(false);
      }
    if (zoneId === "") {
      setZoneErr(true);
      return false;
    } else {
      setZoneErr(false);
    }

    const body = {
      areaName,
      zoneId,
      status,
      documentId: props.documentId
    };

    setLoading(true);
    await axios
      .post(UrlApi + "save_area_work_data", body, authorization)
      .then((res) => {
        props.onCancel();
        AlertSuccess(res.data.message, ()=>{}, 2000);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        AlertError(err);
    });
  };

  const getData = async () => {
    if (props.documentId !== 0) {
      setLoading(true);
      await axios
        .get(
          UrlApi + `get_area_work_data_for_edit?document_id=${props.documentId}`,
          authorization
        )
        .then((res) => {
          setZoneId(res.data[0].zone_master_id);
          setAreaName(res.data[0].order_area_name);
          setZoneName(res.data[0].zone_master_name);
          setStatus(res.data[0].order_area_active);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          AlertError(err);
        });
    }

    setLoading(true);
    await axios
      .get(UrlApi + "get_zone_data", authorization)
      .then((res) => {
        setZoneData(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        AlertError(err);
      });

  };

  const handleEnter = (event) => {
      const id = parseInt(event.target.id);
      const form = event.target.form;
      const index = [...form].indexOf(event.target);
      let next = 2;
      if(event.key === "Enter"){
        if(id === 9){
          onSubmit(event);
          return false;
        }
        switch (id){
          case 2:
            next = 5;
            break;
          case 3:
            next = 4;
            break;
          case 7:
            next = 4;
            break;
          case 8:
              next = 4;
            break;
          default:
            next = 2;
        }
        form.elements[index + next].focus();
        event.preventDefault();
      }
    
  };

  const marginLeft = {
    marginLeft: "9px",
  };


  useEffect(() => {
    getData();
  }, []);
  return (
    <>
      <Dialog
        open={props.open}
        maxWidth="1500"
        PaperProps={{ style: { borderRadius: 10, width: '25%'} }}
      >
        <Box component="form" noValidate onSubmit={(e)=>{onSubmit(e)}} sx={{ mt: 1}}>
          <DialogTitle>
            <label>
              {props.documentId === 0
                ? "เพิ่มพื้นที่สั่งงาน"
                : "แก้ไขพื้นที่สั่งงาน"}
            </label>
          </DialogTitle>
          <DialogContent dividers="paper">
            <form>
              <table style={{width: '100%'}}>             
                <tr>
                  <td colspan="3">
                    <label style={marginLeft}>พิ้นที่สั่งงาน</label>
                    {
                      <TextInput
                        id="4"
                        type="text"
                        onChange={(e) => {
                          setAreaName(e.target.value);
                          setWorkAreaErr(false);
                        }}
                        error={workAreaErr}
                        value={areaName}
                        onKeyDown={handleEnter}
                        width="100%"                      
                      />
                    }
                  </td>
                </tr>              
                <tr>
                  <td colspan="3">
                    <label style={marginLeft}>โซน</label>
                    {
                      <SelectAutoComplete
                        id="7"
                        options={zoneData}
                        onChange={(value, valueText, otherValue) => {
                          setZoneName(valueText);
                          setZoneId(value);
                          setZoneErr(false);
                        }}
                        value={zoneName}
                        onInputChange={(event, newInputValue) => {}}
                        error={zoneErr}
                        width="100%"
                        onKeyDown={handleEnter}
                      />
                    }
                  </td>
                </tr>
                <tr>
                    <td colSpan="5">
                        <label style={{ marginLeft: '9px' }}>สถานะการใช้งาน</label>
                        {
                            <FormGroup style={{ marginLeft: "10px" }}>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={status}
                                            onChange={() => {
                                                setStatus(!status);
                                            }}
                                        />
                                    }
                                    label={
                                        status ? (
                                            <label>เปิดการใช้งาน</label>
                                        ) : (
                                            <label>ปิดการใช้งาน</label>
                                        )
                                    }
                                />
                            </FormGroup>
                        }
                    </td>
                </tr>
              </table>
            </form>
          </DialogContent>
          <DialogActions>
            <ButtonSave type="submit" />
            <ButtonClose onClick={() => props.onCancel()} />
          </DialogActions>
          <Loading open={loading} />
        </Box>
      </Dialog>
    </>
  );
}

export default AddWorkArea;
